export const getPercentDisplaying = (percent: number): string => {
  if (!percent) {
    return '< 0.1%';
  }
  if (percent > 100) {
    return '100%';
  }
  return `${percent}%`;
};
